export default [{
  path: '/raio-x',
  component: {
    name: 'raioxBase',
    template: '<router-view />',
    meta: {
      resource: 'monitoramento_360',
      action: 'read',
      requiredAuth: true,
      breadcrumb: [
        { text: '', to: { path: '/' } },
      ],
    },
  },
  children: [{
    path: 'visualizar',
    name: 'raio-x-view',
    component: () => import('@/app/raio-x/RaioXView.vue'),
    meta: {
      resource: 'monitoramento_360',
      action: 'read',
      navActiveLink: 'raio-x-view',
      pageTitle: 'Raio-X Fiscal',
      breadcrumb: [
        {
          text: 'Raio-X Fiscal',
          to: { name: 'raio-x-view' },
          active: true,
        },
      ],
    },
  }],
},
]
